import { UserApplicationModuleDetailsData } from './user-application-module-details-data.model';
import { LoginOutputMenuData } from './login-output-menu-data.model';


export class LoginOutputData implements ILoginOutputData {
    /** The auto-generated id of the user  master */
    user_id!: number;
    /** The user name  with 255 character limit */
    user_name!: string;
    /** The user mobile  with 13 character limit */
    mobile_no!: string;
    /** The user email address code with 320 character limit */
    email_address!: string;
    /** The user user password with 100 character limit */
    password!: string;
    /** Manage status of user. 0 For De-active, 1 For Active */
    status!: number;
    /** The auto-generated id of the user type master */
    user_type_id!: number;
    /** The user type code with 255 character limit */
    user_type_code!: string;
    /** The user type code with 255 character limit */
    user_type_name!: string;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    user_application_module_details!: UserApplicationModuleDetailsData[];
    /** The user access token */
    access_token!: string;
    /** The user refresh token */
    refresh_token!: string;
    menu!: LoginOutputMenuData[];

    constructor(data?: ILoginOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_id = _data["user_id"];
            this.user_name = _data["user_name"];
            this.mobile_no = _data["mobile_no"];
            this.email_address = _data["email_address"];
            this.password = _data["password"];
            this.status = _data["status"];
            this.user_type_id = _data["user_type_id"];
            this.user_type_code = _data["user_type_code"];
            this.user_type_name = _data["user_type_name"];
            this.company_details_id = _data["company_details_id"];
            if (Array.isArray(_data["user_application_module_details"])) {
                this.user_application_module_details = [] as any;
                for (let item of _data["user_application_module_details"])
                    this.user_application_module_details!.push(UserApplicationModuleDetailsData.fromJS(item));
            }
            this.access_token = _data["access_token"];
            this.refresh_token = _data["refresh_token"];
            if (Array.isArray(_data["menu"])) {
                this.menu = [] as any;
                for (let item of _data["menu"])
                    this.menu!.push(LoginOutputMenuData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LoginOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new LoginOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_id"] = this.user_id;
        data["user_name"] = this.user_name;
        data["mobile_no"] = this.mobile_no;
        data["email_address"] = this.email_address;
        data["password"] = this.password;
        data["status"] = this.status;
        data["user_type_id"] = this.user_type_id;
        data["user_type_code"] = this.user_type_code;
        data["user_type_name"] = this.user_type_name;
        data["company_details_id"] = this.company_details_id;
        if (Array.isArray(this.user_application_module_details)) {
            data["user_application_module_details"] = [];
            for (let item of this.user_application_module_details)
                data["user_application_module_details"].push(item.toJSON());
        }
        data["access_token"] = this.access_token;
        data["refresh_token"] = this.refresh_token;
        if (Array.isArray(this.menu)) {
            data["menu"] = [];
            for (let item of this.menu)
                data["menu"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ILoginOutputData {
    /** The auto-generated id of the user  master */
    user_id: number;
    /** The user name  with 255 character limit */
    user_name: string;
    /** The user mobile  with 13 character limit */
    mobile_no: string;
    /** The user email address code with 320 character limit */
    email_address: string;
    /** The user user password with 100 character limit */
    password: string;
    /** Manage status of user. 0 For De-active, 1 For Active */
    status: number;
    /** The auto-generated id of the user type master */
    user_type_id: number;
    /** The user type code with 255 character limit */
    user_type_code: string;
    /** The user type code with 255 character limit */
    user_type_name: string;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    user_application_module_details: UserApplicationModuleDetailsData[];
    /** The user access token */
    access_token: string;
    /** The user refresh token */
    refresh_token: string;
    menu: LoginOutputMenuData[];
}

